import React from "react";
import { Form} from "react-bootstrap";
import "../styles/AutomationInputContainerInput.css"

interface IAutomationInputContainerInput {
  title: string,
  placholder: string,
  setVal: React.Dispatch<React.SetStateAction<string>>,
  val: string,
  type?: string,
  inputMode?: "text" | "numeric" | "tel" | "email",
  maxLength?: number,
  format?: (v: string) => string,
  isInvalid?: boolean,
  onBlur?: () => void
}

export const AutomationInputContainerInput = ({title, placholder, setVal, val, type = "text", inputMode, maxLength, format, isInvalid, onBlur}: IAutomationInputContainerInput) => {
  return (
    <>
      <label style={{textAlign: "left"}}>{title}</label>
      <Form.Control
        type={type}
        inputMode={inputMode}
        maxLength={maxLength}
        value={val}
        onChange={e => setVal(format ? format(e.target.value) : e.target.value)}
        onBlur={onBlur}
        placeholder={placholder}
        isInvalid={isInvalid}
        className="m_a_aici_contacts_form_inp"
      />
    </>
  );
};
